


























































































































































































import Vue from 'vue';
import { IShoppingCartIndividual, IShoppingCartItem } from '@/common/interfaces/cart.interface';
import { ICustomerOrder, ICustomerOrderAddress, ICustomerOrderItem } from '@/common/interfaces/customers.interface';
import { IPartnerInvoicingPoints } from '@/common/interfaces/partners.interface';
import { IProduct } from '@/common/interfaces/products.interface';
import config from '../../../config';
import CookieHelper from '../../helpers/CookieHelper';
import OldErrorHandlerHelper from '../../helpers/OldErrorHandlerHelper';
import FetchHelper from '../../helpers/OldFetchHelper';
import OldFormatHelper from '../../helpers/OldFormatHelper';
import LanguageHelper from '../../helpers/LanguageHelper';
import TIcons from '../../types/TIcons';
import LinkButton from './buttons/LinkButton.vue';
import ItemsView from './ItemsView.vue';
import ItemsViewInvoicingPoints from './ItemsViewInvoicingPoints.vue';
import TextblockWithHeadline from './TextblockWithHeadline.vue';

interface IOrderViewComponent {
  formatHelper: typeof OldFormatHelper;
  icons: typeof TIcons;
}

export default Vue.extend({
  name: `OrderView`,
  components: {
    ItemsView,
    ItemsViewInvoicingPoints,
    LinkButton,
    TextblockWithHeadline,
  },
  data(): IOrderViewComponent {
    return {
      formatHelper: OldFormatHelper,
      icons: TIcons,
    };
  },
  computed: {
    enableInvoicePaymentSwitch(): boolean {
      if(!this.order) {
        return false;
      }
      return this.order.status === `offen` && this.order.paymentStatus === `open` && this.order.invoicePaymentIsPossible;
    },
    entity(): ICustomerOrder | IPartnerInvoicingPoints | IShoppingCartIndividual | undefined {
      const entity = this.cart || this.order || this.invoicingPoints;
      if(!entity) { // this should never be the case as one of the three props above should be passed into the component
        return undefined;
      }
      if(!entity.sum) {
        entity.sum = {};
      }
      if(this.currency.length > 0) {
        entity.currency = this.currency;
      }
      return entity;
    },
  },
  props: {
    cart: {
      default: null,
      type: Object as () => (IShoppingCartIndividual & { currency: string }) | null,
    },
    currency: {
      default: ``,
      type: String,
    },
    invoicingPoints: {
      default: null,
      type: Object as () => (IPartnerInvoicingPoints & { currency: string; sum: Record<string, unknown> }) | null,
    },
    isCheckout: {
      default: false,
      type: Boolean,
    },
    isPartner: {
      default: false,
      type: Boolean,
    },
    order: {
      default: null,
      type: Object as () => (ICustomerOrder & { invoicePaymentIsPossible: boolean; paymentStatus: string }) | null,
    },
    partnerApplicationProducts: {
      default: () => [],
      type: Array as () => IProduct[],
    },
  },
  methods: {
    async cancelOrder(): Promise<void> {
      if(!this.order) {
        return;
      }
      const fetchConfig = {
        path: `${config.api.paths.customers.basepath}${config.api.paths.customers.paths.orders}/${this.order.orderId}`,
      };

      const ret = await this.$swal({
        showCancelButton: true,
        showConfirmButton: true,
        text: this.$t(`my-orders:cancelOrderReally`) as string,
      });

      if(ret.value) {
        const fetchResult = await FetchHelper.delete(fetchConfig);

        if(!fetchResult.success) {
          await OldErrorHandlerHelper.handleError(fetchResult.message || ``, { showSwal: true });
        }
        window.location.reload();
      }
    },
    getAddressLines(address: ICustomerOrderAddress): string[] {
      return [
        address.recipient,
        address.street,
        `${address.zipCode} ${address.city}`,
        address.country,
        address.extra,
      ];
    },
    repeatOrder(): void {
      OldErrorHandlerHelper.handleError(`not yet implemented`, { showSwal: true });
    },
    repeatPayment(): void {
      // check for partnerApplicationProducts for cookie

      const entity = this.order || this.cart;
      if(!entity || !entity.items) {
        return;
      }

      let isPartnerApplicationOrder = false;
      entity.items.forEach((item: IShoppingCartItem | ICustomerOrderItem): void => {
        this.partnerApplicationProducts.forEach(check => {
          if(item.matchcode === check.matchcode) {
            isPartnerApplicationOrder = true;
          }
        });
      });

      if(isPartnerApplicationOrder) {
        CookieHelper.setPartnerApplicationDone();
      }

      if(this.order) {
        window.location.href = `/payment/?${LanguageHelper.getLanguageParameter()}idsammelbestellung=${this.order.collectiveOrderId}`;
      }
    },
    seeInvoice(orderId: number): void {
      // window.location.href = `https://www.ringana.com/ref/downloads/?mode=invoice&idd=${orderId}`;
      OldErrorHandlerHelper.handleError(`not yet implemented ${orderId}`, { showSwal: true });
    },
    trackOrder(): void {
      // eslint-disable-next-line camelcase
      if(this.order?.tracking_url) {
        window.open(this.order.tracking_url);
      }
    },
    async updatePaymentTypeToInvoice(orderId: number): Promise<void> {
      const fetchConfig = {
        body: { orderId },
        path: `${config.api.paths.customers.basepath}${config.api.paths.customers.paths.updatePaymentType}`,
      };
      const ret = await this.$swal({
        showCancelButton: true,
        showConfirmButton: true,
        text: this.$t(`my-orders:invoicePaymentConfirm`) as string,
      });
      if(!ret.value) {
        return;
      }
      const response = await FetchHelper.patch(fetchConfig);
      if(!response || !response.success) {
        OldErrorHandlerHelper.handleError(response.message || ``, { showSwal: true });
        return;
      }
      window.location.reload();
    },
  },
});
